module.exports = __webpack_public_path__ + "img/KSAM_logo.png";